'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactstrap = require('reactstrap');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
var reactRouterDom = require('react-router-dom');
var Helmet = require('react-helmet');
var NumberFormat = require('react-number-format');
var DatePicker = require('react-date-picker');
var componentLibrary = require('@galop/component-library');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Helmet__default = /*#__PURE__*/_interopDefaultLegacy(Helmet);
var NumberFormat__default = /*#__PURE__*/_interopDefaultLegacy(NumberFormat);
var DatePicker__default = /*#__PURE__*/_interopDefaultLegacy(DatePicker);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var SearchBar = function SearchBar(props) {
  var value = props.value,
      className = props.className;

  var _useState = React.useState(value || ''),
      _useState2 = _slicedToArray(_useState, 2),
      filter = _useState2[0],
      setFilter = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      filterIsDirty = _useState4[0],
      setFilterIsDirty = _useState4[1];

  var _useState5 = React.useState(props.ShowReset),
      _useState6 = _slicedToArray(_useState5, 2),
      showReset = _useState6[0],
      setShowReset = _useState6[1];

  React.useEffect(function () {
    if (filterIsDirty) {
      if (props.onUpdate) {
        props.onUpdate(filter);
      } else if (props.onChange) {
        props.onChange(filter);
      }
    }
  }, [filter]);
  React.useEffect(function () {
    setShowReset(props.ShowReset);
  }, [props.ShowReset]);

  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Escape') {
      resetFilter();
    } else if (e.key === 'Enter') {
      if (props.Enter && typeof props.Enter === 'function') {
        props.Enter();
      }

      setFilterIsDirty(true);
    } else {
      setFilterIsDirty(true);
    }
  };

  var resetFilter = function resetFilter() {
    setFilter('');
    setShowReset(false);

    if (props.Reset) {
      setFilterIsDirty(false);
      props.Reset();
    }
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: className
  }, /*#__PURE__*/React__default['default'].createElement(reactstrap.InputGroup, null, /*#__PURE__*/React__default['default'].createElement(reactstrap.Input, {
    type: "text",
    value: filter,
    onChange: function onChange(e) {
      setFilter(e.target.value);
      setFilterIsDirty(true);
    },
    placeholder: props.placeHolder,
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e);
    }
  }), !props.HideButton || filter ? /*#__PURE__*/React__default['default'].createElement(reactstrap.InputGroupAddon, {
    addonType: "append"
  }, /*#__PURE__*/React__default['default'].createElement(reactstrap.Button, _extends({}, filter !== '' || showReset ? {
    color: 'dark',
    className: 'text-white'
  } : {
    color: 'light',
    className: 'border'
  }, {
    onClick: function onClick() {
      return resetFilter();
    }
  }), /*#__PURE__*/React__default['default'].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: filter !== '' || showReset ? freeSolidSvgIcons.faTimes : freeSolidSvgIcons.faSearch
  }))) : null));
};

var UserPearl = function UserPearl(props) {
  var _useState = React.useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      loadingUser = _useState2[0],
      setLoadingUser = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hover = _useState4[0],
      setHover = _useState4[1];

  var className = props.className;
  React.useEffect(function () {
    if (props.CurrentUser) {
      setLoadingUser(false);
    } else {
      setLoadingUser(true);
    }
  }, [props.CurrentUser]);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ml-auto-sm ".concat(className)
  }, loadingUser || !props.CurrentUser ? null : /*#__PURE__*/React__default['default'].createElement("ul", {
    className: "navbar-nav flex-grow"
  }, /*#__PURE__*/React__default['default'].createElement(reactstrap.NavItem, null, /*#__PURE__*/React__default['default'].createElement(reactstrap.UncontrolledButtonDropdown, null, /*#__PURE__*/React__default['default'].createElement(reactstrap.DropdownToggle, {
    tag: 'div'
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "p-0 text-white rounded-circle d-table-cell align-middle text-center cursor-pointer ".concat(hover ? 'bg-secondary' : 'bg-dark'),
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    style: {
      width: 40,
      height: 40
    }
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    style: {
      fontWeight: 'bold'
    }
  }, props.CurrentUser.initials))), /*#__PURE__*/React__default['default'].createElement(reactstrap.DropdownMenu, {
    right: true
  }, /*#__PURE__*/React__default['default'].createElement(reactstrap.DropdownItem, {
    header: true,
    className: "d-block d-sm-none"
  }, props.CurrentUser.name), /*#__PURE__*/React__default['default'].createElement(reactstrap.DropdownItem, {
    divider: true,
    className: "d-block d-sm-none"
  }), /*#__PURE__*/React__default['default'].createElement(reactstrap.DropdownItem, {
    tag: reactRouterDom.Link,
    to: "/logout"
  }, "Logout"))))));
};

var Title = function Title(props) {
  var title = props.title,
      subtitle = props.subtitle,
      AppName = props.AppName;
  return /*#__PURE__*/React__default['default'].createElement(Helmet__default['default'], null, subtitle ? /*#__PURE__*/React__default['default'].createElement("title", null, subtitle, " | ", title || AppName || 'My GALOP App') : /*#__PURE__*/React__default['default'].createElement("title", null, title || AppName || 'My GALOP App'));
};
var PageTitle = function PageTitle(props) {
  var moduleName = props.moduleName,
      subtitle = props.subtitle,
      titleChild = props.titleChild;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "mb-0 mb-sm-2"
  }, /*#__PURE__*/React__default['default'].createElement(Title, {
    subtitle: subtitle || moduleName,
    AppName: props.AppName
  }), /*#__PURE__*/React__default['default'].createElement(reactstrap.Row, null, /*#__PURE__*/React__default['default'].createElement(reactstrap.Col, _extends({}, _objectSpread2({
    lg: '8',
    xl: '5'
  }, props.size), {
    className: "align-middle pr-0",
    style: {
      borderBottom: 2,
      borderBottomStyle: 'solid',
      borderBottomColor: '#909090'
    }
  }), /*#__PURE__*/React__default['default'].createElement("h3", {
    className: "text-secondary d-flex ".concat(props.flexBehavior || 'flex-column flex-sm-row')
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "mr-sm-2"
  }, moduleName), titleChild)), props.children));
};

var CancelButton = function CancelButton(props) {
  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var Close = props.Close,
      Reload = props.Reload,
      ShowDropdown = props.ShowDropdown,
      otherProps = _objectWithoutProperties(props, ["Close", "Reload", "ShowDropdown"]);

  return /*#__PURE__*/React__default['default'].createElement("span", null, ShowDropdown ? /*#__PURE__*/React__default['default'].createElement(reactstrap.ButtonDropdown, {
    direction: "up",
    isOpen: isOpen,
    toggle: function toggle() {
      return setIsOpen(!isOpen);
    }
  }, /*#__PURE__*/React__default['default'].createElement(reactstrap.DropdownToggle, _extends({}, otherProps, {
    caret: true
  }), props.children), /*#__PURE__*/React__default['default'].createElement(reactstrap.DropdownMenu, {
    right: true
  }, /*#__PURE__*/React__default['default'].createElement(reactstrap.DropdownItem, {
    header: true
  }, "Are you sure you want to cancel your changes?"), /*#__PURE__*/React__default['default'].createElement(reactstrap.DropdownItem, {
    divider: true
  }), Reload && /*#__PURE__*/React__default['default'].createElement(reactstrap.DropdownItem, {
    key: "cancel-2",
    onClick: function onClick() {
      return Reload();
    }
  }, "Cancel Changes and Reload"), Close && /*#__PURE__*/React__default['default'].createElement(reactstrap.DropdownItem, {
    key: "cancel-1",
    onClick: function onClick() {
      return Close();
    }
  }, "Cancel Changes", Reload && ' and Close'))) : /*#__PURE__*/React__default['default'].createElement(reactstrap.Button, _extends({}, otherProps, {
    onClick: function onClick() {
      return (Close || Reload)();
    }
  }), props.children));
};
var DeleteButton = function DeleteButton(props) {
  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];

  var Close = props.Close,
      ShowDropdown = props.ShowDropdown;
      props.className;
      var OverrideText = props.OverrideText,
      otherProps = _objectWithoutProperties(props, ["Close", "ShowDropdown", "className", "OverrideText"]);

  return /*#__PURE__*/React__default['default'].createElement("span", null, ShowDropdown ? /*#__PURE__*/React__default['default'].createElement(reactstrap.ButtonDropdown, {
    direction: "up",
    isOpen: isOpen,
    toggle: function toggle() {
      return setIsOpen(!isOpen);
    }
  }, /*#__PURE__*/React__default['default'].createElement(reactstrap.DropdownToggle, _extends({}, otherProps, {
    caret: true
  }), props.children), /*#__PURE__*/React__default['default'].createElement(reactstrap.DropdownMenu, null, /*#__PURE__*/React__default['default'].createElement(reactstrap.DropdownItem, {
    header: true
  }, !OverrideText ? /*#__PURE__*/React__default['default'].createElement("span", null, "Are you sure you want to ", props.children, " this record?") : OverrideText), /*#__PURE__*/React__default['default'].createElement(reactstrap.DropdownItem, {
    divider: true
  }), /*#__PURE__*/React__default['default'].createElement(reactstrap.DropdownItem, {
    onClick: function onClick() {
      return Close();
    }
  }, props.children))) : /*#__PURE__*/React__default['default'].createElement(reactstrap.Button, _extends({}, otherProps, {
    onClick: function onClick() {
      return Close();
    }
  }), props.children));
};

var ExpandableBox = function ExpandableBox(props) {
  var ShowButton = props.ShowButton,
      Toggle = props.Toggle,
      IsOpen = props.IsOpen;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "border rounded mb-2 ".concat(IsOpen ? 'scrollable-list' : '')
  }, props.children, ShowButton && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "text-center border-top bg-light cursor-pointer",
    onClick: Toggle
  }, /*#__PURE__*/React__default['default'].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: IsOpen ? freeSolidSvgIcons.faChevronUp : freeSolidSvgIcons.faChevronDown
  })));
};

require('load-styles')("/*  imported from Field.css  */\n\n.react-date-picker__wrapper {\n    border: 0;\n}");

var Field = /*#__PURE__*/React__default['default'].forwardRef(function (props, ref) {
  var fieldClassName = props.fieldClassName,
      Horizontal = props.Horizontal;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      popoverOpen = _useState2[0],
      setPopoverOpen = _useState2[1];

  var fieldEditor = function fieldEditor() {
    switch (props.type) {
      case 'checkbox':
      case 'radio':
        return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(reactstrap.Label, {
          className: "sr-only"
        }, props.showLabels || props.showLabels === undefined ? props.label : props.field), /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(reactstrap.Label, {
          check: true
        }, /*#__PURE__*/React__default['default'].createElement(reactstrap.Input, _extends({
          type: props.type,
          ref: ref,
          name: props.field,
          value: props.value || ''
        }, props.EnableInput, {
          onChange: props.onChange,
          checked: props.selectedValue === props.value ? 'checked' : ''
        })), " ", props.showLabels || props.showLabels === undefined ? props.label : props.field), "\xA0"));

      case 'file':
        return /*#__PURE__*/React__default['default'].createElement("div", {
          className: Horizontal && 'd-flex'
        }, (props.field || props.label) && !props.HideLabel && /*#__PURE__*/React__default['default'].createElement("div", {
          className: "d-flex align-items-start ".concat(Horizontal ? 'w-50' : '')
        }, /*#__PURE__*/React__default['default'].createElement(reactstrap.Label, {
          className: "".concat(Horizontal ? 'form-control-plaintext mr-2' : ''),
          for: props.field
        }, props.showLabels || props.showLabels === undefined ? props.label : props.field), props.info && /*#__PURE__*/React__default['default'].createElement(reactFontawesome.FontAwesomeIcon, {
          id: "".concat(props.field || 'field', "_info"),
          className: "text-info ml-1",
          icon: freeSolidSvgIcons.faInfoCircle,
          onClick: function onClick() {
            return setPopoverOpen(!popoverOpen);
          }
        }), props.info && /*#__PURE__*/React__default['default'].createElement(reactstrap.Popover, {
          placement: "top",
          trigger: "focus",
          isOpen: popoverOpen,
          target: "".concat(props.field || 'field', "_info"),
          toggle: function toggle() {
            return setPopoverOpen(!popoverOpen);
          }
        }, /*#__PURE__*/React__default['default'].createElement(reactstrap.PopoverBody, null, props.info))), /*#__PURE__*/React__default['default'].createElement(reactstrap.InputGroup, null, /*#__PURE__*/React__default['default'].createElement("div", {
          className: "custom-file"
        }, /*#__PURE__*/React__default['default'].createElement(reactstrap.Input, _extends({
          ref: ref,
          id: props.field,
          name: props.field,
          type: props.type
        }, props.EnableInput, {
          onChange: props.onChange,
          onKeyDown: props.onKeyDown
        }, props.focus ? {
          autofocus: ''
        } : null, {
          accept: props.accept,
          className: "".concat(fieldClassName, " custom-file-input ").concat(props.validation !== undefined && props.validation[props.field].isInvalid ? 'is-invalid' : (props.EnableInput || {
            className: ''
          }).className, " ").concat(props.children !== undefined ? 'custom-select' : '', " ")
        }), props.children || null), /*#__PURE__*/React__default['default'].createElement(reactstrap.Label, {
          className: "custom-file-label"
        }, props.value ? props.value : 'Choose file'))));

      case 'currency':
      case 'number':
        return /*#__PURE__*/React__default['default'].createElement("div", {
          className: Horizontal && 'd-flex'
        }, (props.field || props.label) && !props.HideLabel && /*#__PURE__*/React__default['default'].createElement("div", {
          className: "d-flex align-items-start ".concat(Horizontal ? 'w-50' : '')
        }, /*#__PURE__*/React__default['default'].createElement(reactstrap.Label, {
          className: Horizontal && 'form-control-plaintext mr-2',
          for: props.field
        }, props.showLabels || props.showLabels === undefined ? props.label : props.field), props.info && /*#__PURE__*/React__default['default'].createElement(reactFontawesome.FontAwesomeIcon, {
          id: "".concat(props.field || 'field', "_info"),
          className: "text-info ml-1",
          icon: freeSolidSvgIcons.faInfoCircle,
          onClick: function onClick() {
            return setPopoverOpen(!popoverOpen);
          }
        }), props.info && /*#__PURE__*/React__default['default'].createElement(reactstrap.Popover, {
          placement: "top",
          trigger: "focus",
          isOpen: popoverOpen,
          target: "".concat(props.field || 'field', "_info"),
          toggle: function toggle() {
            return setPopoverOpen(!popoverOpen);
          }
        }, /*#__PURE__*/React__default['default'].createElement(reactstrap.PopoverBody, null, props.info))), /*#__PURE__*/React__default['default'].createElement(reactstrap.InputGroup, {
          className: Horizontal && 'flex-fill w-50'
        }, props.unit && props.left ? /*#__PURE__*/React__default['default'].createElement(reactstrap.InputGroupAddon, {
          addonType: "prepend"
        }, props.unit) : null, props.onClick && props.left ? /*#__PURE__*/React__default['default'].createElement(reactstrap.InputGroupAddon, {
          addonType: "prepend"
        }, /*#__PURE__*/React__default['default'].createElement(reactstrap.Button, {
          color: props.actionColor || 'light',
          className: props.actionColor || props.actionBorder ? "border-".concat(props.actionBorder || props.actionColor) : 'border',
          onClick: props.onClick
        }, /*#__PURE__*/React__default['default'].createElement(reactFontawesome.FontAwesomeIcon, {
          icon: props.actionIcon
        }))) : null, /*#__PURE__*/React__default['default'].createElement(NumberFormat__default['default'], _extends({
          ref: ref,
          id: props.field,
          name: props.field,
          type: "text",
          value: props.value || ''
        }, props.EnableInput, {
          onValueChange: props.onValueChange,
          onChange: props.onChange,
          onKeyDown: props.onKeyDown
        }, props.focus ? {
          autofocus: ''
        } : null, {
          placeholder: props.PlaceHolder || '',
          thousandSeparator: true,
          decimalScale: props.decimalScale || '2',
          fixedDecimalScale: true,
          decimalSeparator: props.decimalSeparator || '.',
          className: "form-control text-right ".concat(fieldClassName, " ").concat(props.validation && (props.validation[props.field] || {}).isInvalid ? 'is-invalid' : (props.EnableInput || {
            className: ''
          }).className)
        })), props.unit && !props.left ? /*#__PURE__*/React__default['default'].createElement(reactstrap.InputGroupAddon, {
          addonType: "append"
        }, props.unit) : null, props.onClick && !props.left ? /*#__PURE__*/React__default['default'].createElement(reactstrap.InputGroupAddon, {
          addonType: "append"
        }, /*#__PURE__*/React__default['default'].createElement(reactstrap.Button, {
          color: props.actionColor || 'light',
          className: props.actionColor || props.actionBorder ? "border-".concat(props.actionBorder || props.actionColor) : 'border',
          outline: props.outline,
          disabled: (props.EnableInput || {}).disabled,
          onClick: props.onClick
        }, /*#__PURE__*/React__default['default'].createElement(reactFontawesome.FontAwesomeIcon, {
          icon: props.actionIcon
        }))) : null));

      case 'date':
        return /*#__PURE__*/React__default['default'].createElement("div", {
          className: Horizontal && 'd-flex'
        }, (props.field || props.label) && !props.HideLabel && /*#__PURE__*/React__default['default'].createElement("div", {
          className: "d-flex align-items-start ".concat(Horizontal ? 'w-50' : '')
        }, /*#__PURE__*/React__default['default'].createElement(reactstrap.Label, {
          className: "".concat(Horizontal ? 'form-control-plaintext mr-2' : ''),
          for: props.field
        }, props.showLabels || props.showLabels === undefined ? props.label : props.field), props.info && /*#__PURE__*/React__default['default'].createElement(reactFontawesome.FontAwesomeIcon, {
          id: "".concat(props.field || 'field', "_info"),
          className: "text-info ml-1",
          icon: freeSolidSvgIcons.faInfoCircle,
          onClick: function onClick() {
            return setPopoverOpen(!popoverOpen);
          }
        }), props.info && /*#__PURE__*/React__default['default'].createElement(reactstrap.Popover, {
          placement: "top",
          trigger: "focus",
          isOpen: popoverOpen,
          target: "".concat(props.field || 'field', "_info"),
          toggle: function toggle() {
            return setPopoverOpen(!popoverOpen);
          }
        }, /*#__PURE__*/React__default['default'].createElement(reactstrap.PopoverBody, null, props.info))), /*#__PURE__*/React__default['default'].createElement(reactstrap.InputGroup, {
          className: Horizontal && 'flex-fill w-50'
        }, props.unit && props.left ? /*#__PURE__*/React__default['default'].createElement(reactstrap.InputGroupAddon, {
          addonType: "prepend"
        }, props.unit) : null, props.onClick && props.left ? /*#__PURE__*/React__default['default'].createElement(reactstrap.InputGroupAddon, {
          addonType: "prepend"
        }, /*#__PURE__*/React__default['default'].createElement(reactstrap.Button, {
          color: props.actionColor || 'light',
          className: props.actionColor || props.actionBorder ? "border-".concat(props.actionBorder || props.actionColor) : 'border',
          onClick: props.onClick
        }, /*#__PURE__*/React__default['default'].createElement(reactFontawesome.FontAwesomeIcon, {
          icon: props.actionIcon
        }))) : null, /*#__PURE__*/React__default['default'].createElement(DatePicker__default['default'], _extends({
          ref: ref,
          id: props.field,
          name: props.field,
          type: props.type,
          value: props.value || ''
        }, props.EnableInput, props.EnableInput && props.EnableInput.disabled ? {
          clearIcon: null,
          calendarIcon: null
        } : {}, {
          onChange: props.onChange,
          onKeyDown: props.onKeyDown,
          minDate: new Date(props.minDate),
          maxDate: new Date(props.maxDate)
        }, props.focus ? {
          autofocus: ''
        } : null, {
          placeholder: props.PlaceHolder || '',
          className: "form-control ".concat(fieldClassName, " ").concat(props.validation && (props.validation[props.field] || {}).isInvalid ? 'is-invalid' : (props.EnableInput || {
            className: ''
          }).className, " ").concat(props.children !== undefined ? 'custom-select' : '', " ")
        }), props.children || null), props.unit && !props.left ? /*#__PURE__*/React__default['default'].createElement(reactstrap.InputGroupAddon, {
          addonType: "append"
        }, props.unit) : null, props.onClick && !props.left ? /*#__PURE__*/React__default['default'].createElement(reactstrap.InputGroupAddon, {
          addonType: "append"
        }, /*#__PURE__*/React__default['default'].createElement(reactstrap.Button, {
          color: props.actionColor || 'light',
          className: props.actionColor || props.actionBorder ? "border-".concat(props.actionBorder || props.actionColor) : 'border',
          outline: props.outline,
          disabled: (props.EnableInput || {}).disabled,
          onClick: props.onClick
        }, /*#__PURE__*/React__default['default'].createElement(reactFontawesome.FontAwesomeIcon, {
          icon: props.actionIcon
        }))) : null));

      default:
        return /*#__PURE__*/React__default['default'].createElement("div", {
          className: Horizontal && 'd-flex'
        }, (props.field || props.label) && !props.HideLabel && /*#__PURE__*/React__default['default'].createElement("div", {
          className: "d-flex align-items-start ".concat(Horizontal ? 'w-50' : '')
        }, /*#__PURE__*/React__default['default'].createElement(reactstrap.Label, {
          className: "".concat(Horizontal ? 'form-control-plaintext mr-2' : ''),
          for: props.field
        }, props.showLabels || props.showLabels === undefined ? props.label : props.field), props.info && /*#__PURE__*/React__default['default'].createElement(reactFontawesome.FontAwesomeIcon, {
          id: "".concat(props.field || 'field', "_info"),
          className: "text-info ml-1",
          icon: freeSolidSvgIcons.faInfoCircle,
          onClick: function onClick() {
            return setPopoverOpen(!popoverOpen);
          }
        }), props.info && /*#__PURE__*/React__default['default'].createElement(reactstrap.Popover, {
          placement: "top",
          trigger: "focus",
          isOpen: popoverOpen,
          target: "".concat(props.field || 'field', "_info"),
          toggle: function toggle() {
            return setPopoverOpen(!popoverOpen);
          }
        }, /*#__PURE__*/React__default['default'].createElement(reactstrap.PopoverBody, null, props.info))), /*#__PURE__*/React__default['default'].createElement(reactstrap.InputGroup, {
          className: Horizontal && 'flex-fill w-50'
        }, props.unit && props.left ? /*#__PURE__*/React__default['default'].createElement(reactstrap.InputGroupAddon, {
          addonType: "prepend"
        }, props.unit) : null, props.onClick && props.left ? /*#__PURE__*/React__default['default'].createElement(reactstrap.InputGroupAddon, {
          addonType: "prepend"
        }, /*#__PURE__*/React__default['default'].createElement(reactstrap.Button, {
          color: props.actionColor || 'light',
          className: props.actionColor || props.actionBorder ? "border-".concat(props.actionBorder || props.actionColor) : 'border',
          onClick: props.onClick
        }, /*#__PURE__*/React__default['default'].createElement(reactFontawesome.FontAwesomeIcon, {
          icon: props.actionIcon
        }))) : null, /*#__PURE__*/React__default['default'].createElement(reactstrap.Input, _extends({
          ref: ref,
          id: props.field,
          name: props.field,
          type: props.type,
          value: props.value || ''
        }, props.EnableInput, {
          onChange: props.onChange,
          onKeyDown: props.onKeyDown
        }, props.focus ? {
          autofocus: ''
        } : null, {
          placeholder: props.PlaceHolder || '',
          className: "".concat(fieldClassName, " ").concat(props.validation && (props.validation[props.field] || {}).isInvalid ? 'is-invalid' : (props.EnableInput || {
            className: ''
          }).className, " ").concat(props.children !== undefined ? 'custom-select' : '', " ")
        }), props.children || null), props.unit && !props.left ? /*#__PURE__*/React__default['default'].createElement(reactstrap.InputGroupAddon, {
          addonType: "append"
        }, props.unit) : null, props.onClick && !props.left ? /*#__PURE__*/React__default['default'].createElement(reactstrap.InputGroupAddon, {
          addonType: "append"
        }, /*#__PURE__*/React__default['default'].createElement(reactstrap.Button, {
          color: props.actionColor || 'light',
          className: props.actionColor || props.actionBorder ? "border-".concat(props.actionBorder || props.actionColor) : 'border',
          outline: props.outline,
          disabled: (props.EnableInput || {}).disabled,
          onClick: props.onClick
        }, /*#__PURE__*/React__default['default'].createElement(reactFontawesome.FontAwesomeIcon, {
          icon: props.actionIcon
        }))) : null));
    }
  };

  return /*#__PURE__*/React__default['default'].createElement(reactstrap.FormGroup, {
    check: props.type === 'checkbox' || props.type === 'radio',
    inline: props.inline,
    style: {
      marginBottom: 0
    },
    className: props.className
  }, fieldEditor(), !props.HideHelp ? /*#__PURE__*/React__default['default'].createElement("div", null, props.validation && (props.validation[props.field] || {}).isInvalid ? /*#__PURE__*/React__default['default'].createElement("div", {
    className: "invalid-feedback d-block"
  }, props.validation[props.field].message, "\xA0") : !props.stack || props.help !== undefined ? /*#__PURE__*/React__default['default'].createElement("small", {
    className: "text-muted"
  }, props.help !== '' ? props.help : null, "\xA0") : null) : null);
});

var SearchableSelect = function SearchableSelect(props) {
  var HideButton = props.HideButton;
      props.type;
      var children = props.children;
      props.right;
      var PlaceHolder = props.PlaceHolder,
      value = props.value,
      onChange = props.onChange,
      otherProps = _objectWithoutProperties(props, ["HideButton", "type", "children", "right", "PlaceHolder", "value", "onChange"]);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = React.useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      searchText = _useState4[0],
      setSearchText = _useState4[1];

  var _useState5 = React.useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedText = _useState6[0],
      setSelectedText = _useState6[1];

  var descriptionOptionText = children && children.length > 0 && (children[0] || {}).type === 'option' ? (children[0] || {}).props.children : '';

  var _useState7 = React.useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      filteredOptions = _useState8[0],
      setFilteredOptions = _useState8[1];

  var _useState9 = React.useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      hasOptionGroups = _useState10[0],
      setHasOptionGroups = _useState10[1];

  React.useEffect(function () {
    FindValue(value);
  }, [value]);
  React.useEffect(function () {
    if ((props.EnableInput || {}).disabled) {
      setIsOpen(false);
    }
  }, [props.EnableInput]);
  React.useEffect(function () {
    SearchOptions();
  }, [searchText, children]);

  var FindValue = function FindValue(selectedValue) {
    if (selectedValue && children) {
      var find = function find(child) {
        if (child) {
          var isfound = child.props && child.props.value && child.props.value === selectedValue && child.props.children;

          if (!isfound && Array.isArray(child)) {
            isfound = child.find(find);
          } else if (!isfound && child.props && child.props.children && Array.isArray(child.props.children)) {
            isfound = child.props.children.find(find);
          }

          if (isfound && typeof isfound === 'string') {
            setSelectedText(isfound);
          } else {
            return isfound;
          }
        } else {
          return false;
        }
      };

      children.find(find);
    }
  };

  var filter = function filter(option) {
    var isFound = false;

    if (option.type === 'optgroup') {
      isFound = option.props.label.toLowerCase().includes(searchText.toLowerCase());
    } else if (option.type === 'option') {
      isFound = option.props.children.toLowerCase().includes(searchText.toLowerCase());
    }

    if (!isFound && option.props.children && Array.isArray(option.props.children)) {
      isFound = option.props.children.find(filter);
    }

    return isFound;
  };

  var SearchOptions = function SearchOptions() {
    var options = children && Array.isArray(children) ? _toConsumableArray(children) : [children];

    if (options) {
      var optionsIsArray = Array.isArray(options);
      /* Remove Description Option ("Select...") */

      if (options && options.length > 1 && (options[0] || {}).type === 'option') {
        options = _toConsumableArray(options.splice(1));
      }
      /* Check if section child is array */


      if (Array.isArray(options[0])) {
        options = _toConsumableArray(options[0]);
      } else if ((options || {}).type === 'optgroup') {
        options = _toConsumableArray(options.props.children);
        optionsIsArray = Array.isArray(options);
      }
      /* Perform the search */


      if (searchText) {
        setSelectedText('');
        options = options.filter(filter);
      }
      /* Hide the menu, if there aren't any options */


      if (options && optionsIsArray && options.length === 0) {
        setIsOpen(false);
      } else if (optionsIsArray) {
        setHasOptionGroups(options.every(function (option) {
          return (option || {}).type === 'optgroup';
        }));
      }

      setFilteredOptions(options);
    }
  };

  var childMap = function childMap(option) {
    return option ? /*#__PURE__*/React__default['default'].createElement(reactstrap.ListGroupItem, {
      key: option.key,
      className: "text-truncate cursor-pointer",
      title: option.props.children,
      onClick: function onClick() {
        setSearchText('');
        setIsOpen(false);
        onChange({
          target: {
            value: option.props.value,
            name: props.field
          }
        });
      },
      action: true,
      active: option.props.children === selectedText
    }, option.props.children) : null;
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "w-100"
  }, /*#__PURE__*/React__default['default'].createElement(Field, _extends({
    type: "text",
    value: selectedText || searchText
  }, otherProps, {
    PlaceHolder: PlaceHolder || descriptionOptionText,
    actionBorder: props.fieldClassName && props.fieldClassName.includes('is-invalid') ? 'danger' : null,
    actionIcon: !HideButton ? isOpen ? freeSolidSvgIcons.faCaretUp : freeSolidSvgIcons.faCaretDown : null,
    onClick: !HideButton ? function () {
      return setIsOpen(!isOpen);
    } : null,
    onKeyDown: function onKeyDown() {
      return setIsOpen(true);
    },
    onChange: function onChange(e) {
      return setSearchText(e.target.value);
    }
  })), children && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(isOpen ? 'd-block' : 'd-none', " position-absolute border rounded bg-white w-75 shadow-sm"),
    style: {
      zIndex: 1000,
      marginTop: '-1em',
      maxHeight: 250,
      overflow: 'scroll'
    }
  }, !hasOptionGroups ? /*#__PURE__*/React__default['default'].createElement(reactstrap.ListGroup, {
    flush: true
  }, filteredOptions.map(childMap)) : filteredOptions.map(function (child) {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      key: child.key
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "h6 text-truncate border-bottom p-2 mb-1 bg-light shadow-sm",
      title: child.props.label
    }, child.props.label), (child.props.children || []).find(filter) ? /*#__PURE__*/React__default['default'].createElement(reactstrap.ListGroup, {
      flush: true,
      className: "border-bottom"
    }, (child.props.children || []).filter(filter).map(childMap)) : /*#__PURE__*/React__default['default'].createElement(reactstrap.ListGroup, {
      flush: true,
      className: "border-bottom"
    }, (child.props.children || []).map(childMap)));
  })));
};

var SelectCollection = function SelectCollection(props) {
  var options = props.options,
      selectedCollection = props.selectedCollection,
      identifyingField = props.identifyingField,
      selectLabel = props.selectLabel,
      editable = props.editable,
      UpdateCollection = props.UpdateCollection,
      className = props.className,
      help = props.help,
      otherProps = _objectWithoutProperties(props, ["options", "selectedCollection", "identifyingField", "selectLabel", "editable", "UpdateCollection", "className", "help"]);

  var _useState = React.useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      filteredOptions = _useState2[0],
      setFilteredOptions = _useState2[1];

  React.useEffect(function () {
    filterOptions(options);
  }, [selectedCollection, options]);

  var filterOptions = function filterOptions(unfiltered) {
    var filtered = (unfiltered || []).filter(function (option) {
      return !(selectedCollection || []).map(function (selected) {
        return selected[identifyingField];
      }).includes(option.value);
    });
    setFilteredOptions(filtered);
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: className
  }, /*#__PURE__*/React__default['default'].createElement(componentLibrary.Field, _extends({
    type: "select"
  }, otherProps, {
    fieldClassName: "mb-1",
    EnableInput: {
      disabled: filteredOptions && filteredOptions.length === 0 || !editable
    },
    onChange: function onChange(e) {
      return UpdateCollection(e.target.value);
    },
    HideHelp: true
  }), /*#__PURE__*/React__default['default'].createElement("option", null, selectLabel || "Select a ".concat(otherProps.label)), filteredOptions.map(function (option) {
    return /*#__PURE__*/React__default['default'].createElement("option", {
      key: option.value,
      value: option.value
    }, option.text);
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "border rounded p-1",
    style: {
      minHeight: 35
    }
  }, selectedCollection && selectedCollection.length > 0 && options.filter(function (option) {
    return selectedCollection.map(function (selected) {
      return selected[identifyingField];
    }).includes(option.value);
  }).map(function (option) {
    return /*#__PURE__*/React__default['default'].createElement(reactstrap.Badge, {
      key: "".concat(option.value, "_badge"),
      className: "mr-1 shadow-sm ".concat(editable ? '' : 'border'),
      color: editable ? 'secondary' : 'light'
    }, option.text, " ", editable && /*#__PURE__*/React__default['default'].createElement(reactFontawesome.FontAwesomeIcon, {
      className: "cursor-pointer",
      icon: freeSolidSvgIcons.faTimes,
      onClick: function onClick() {
        return UpdateCollection(option.value, true);
      }
    }));
  })), help && !otherProps.HideHelp && /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("small", {
    className: "text-muted"
  }, help)));
};

exports.CancelButton = CancelButton;
exports.DeleteButton = DeleteButton;
exports.ExpandableBox = ExpandableBox;
exports.Field = Field;
exports.PageTitle = PageTitle;
exports.SearchBar = SearchBar;
exports.SearchableSelect = SearchableSelect;
exports.SelectCollection = SelectCollection;
exports.Title = Title;
exports.UserPearl = UserPearl;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@galop/component-library/dist/index.cjs.js
// module id = 3
// module chunks = 0